import { Card, CardContent, CardFooter, CardTitle } from "@ui/card";
import { ProgressBar } from "./ShadcnProgressBar";

interface FullBookCardProps {
  image: string;
  title: string;
  author: string;
  progress: number;
  onClick?: () => void;
  isLockedContent?: boolean;
  withProgress?: "False" | "True" | undefined;
}
const FullBookCard = ({
  image,
  title,
  author,
  progress,
  onClick,
  isLockedContent,
  withProgress,
}: FullBookCardProps) => {
  return (
    <Card className="cursor-pointer border-none p-0" onClick={onClick}>
      <CardContent className="relative flex h-[227px] w-[153px] items-center justify-center p-0">
        <img src={image} alt="None" className="h-full w-full rounded-lg" />
        {isLockedContent ? (
          <div className="absolute bottom-[11px] left-[15px] flex h-[31px] w-[31px] items-center justify-center rounded-full bg-[linear-gradient(180deg,_rgba(255,_204,_101,_0.90)_0%,_rgba(255,_191,_62,_0.95)_100%)]">
            <img src="/assets/icons/premium.svg" alt="premium" className="" />
          </div>
        ) : null}
      </CardContent>
      <div className="flex max-w-[165px] flex-col">
        <CardTitle>
          <div className="line-clamp-1 overflow-hidden text-ellipsis p-2 text-[20px] font-normal  leading-10 dark:text-white">
            {title}
          </div>
        </CardTitle>
        <CardFooter className="flex w-full flex-col items-start justify-between px-2 pb-2">
          <div className="line-clamp-1 text-[16px] text-[#91949C]">
            {author}
          </div>
          {withProgress === "True" && (
            <div className="flex w-full items-center justify-center gap-3">
              <ProgressBar value={progress * 100} height="h-1" />
              <div className="text-[#B5B5B5]">
                {(progress * 100).toFixed()}%
              </div>
            </div>
          )}
        </CardFooter>
      </div>
    </Card>
  );
};

export default FullBookCard;
